import React from 'react';
import { number, string } from 'prop-types';
import THEME from '../../constants/theme';

const CheckSquare = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1382 2.19526C15.3986 2.45561 15.3986 2.87772 15.1382 3.13807L8.47157 9.80474C8.21122 10.0651 7.78911 10.0651 7.52876 9.80474L5.52876 7.80474C5.26841 7.54439 5.26841 7.12228 5.52876 6.86193C5.78911 6.60158 6.21122 6.60158 6.47157 6.86193L8.00016 8.39052L14.1954 2.19526C14.4558 1.93491 14.8779 1.93491 15.1382 2.19526Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.3335 2.66732C3.15668 2.66732 2.98712 2.73756 2.86209 2.86258C2.73707 2.9876 2.66683 3.15717 2.66683 3.33398V12.6673C2.66683 12.8441 2.73707 13.0137 2.86209 13.1387C2.98712 13.2637 3.15669 13.334 3.3335 13.334H12.6668C12.8436 13.334 13.0132 13.2637 13.1382 13.1387C13.2633 13.0137 13.3335 12.8441 13.3335 12.6673V8.00065C13.3335 7.63246 13.632 7.33398 14.0002 7.33398C14.3684 7.33398 14.6668 7.63246 14.6668 8.00065V12.6673C14.6668 13.1978 14.4561 13.7065 14.081 14.0815C13.706 14.4566 13.1973 14.6673 12.6668 14.6673H3.3335C2.80306 14.6673 2.29436 14.4566 1.91928 14.0815C1.54421 13.7065 1.3335 13.1978 1.3335 12.6673V3.33398C1.3335 2.80355 1.54421 2.29484 1.91928 1.91977C2.29436 1.5447 2.80306 1.33398 3.3335 1.33398H10.6668C11.035 1.33398 11.3335 1.63246 11.3335 2.00065C11.3335 2.36884 11.035 2.66732 10.6668 2.66732H3.3335Z"
      fill={color}
    />
  </svg>
);

CheckSquare.propTypes = {
  size: number,
  color: string,
};

CheckSquare.defaultProps = {
  size: 16,
  color: THEME.primaryColors.black,
};

export default CheckSquare;
